var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Message, MessageStates } from "sb-resp-ui";
import { getHeaderNames } from "../../../helpers";
import { RenderSubheading, RenderEvents, ViewAllLink, ViewAllBtn, RenderMainHeading, RenderFavorites, RenderCustomHeading, Placeholder, MiniPlaceholder } from "../components";
import "blocks/EventListPresenter/ui/EventListPresenter.less";
var EventListPresenter = /** @class */ (function (_super) {
    __extends(EventListPresenter, _super);
    function EventListPresenter(props) {
        var _this = _super.call(this, props) || this;
        _this.dict = _this.props.dict;
        _this.cms = _this.props.cms;
        _this.state = _this.props.dataProvider;
        _this.renderedSubheadings = 0;
        _this.renderedMainheadings = 0;
        return _this;
    }
    EventListPresenter.prototype.getSportFilterProps = function () {
        return {
            shouldShow: !this.state.isMiniEventCard && this.cms.ShowSortingFilter,
            handler: this.state.changeSubGrouping,
            subGroupBy: this.state.subGroupBy,
            dict: {
                League: this.dict.League,
                Time: this.dict.Time,
                SortBy: this.dict.SortBy
            },
            isDesktop: this.state.deviceDetect.isDesktop
        };
    };
    EventListPresenter.prototype.getDefaultHeadingProps = function (index, mainHeading, subHeading) {
        var isMain = !subHeading;
        var heading = subHeading || mainHeading;
        var eventFunction = isMain ? "displayEventByMainGrouping" : "displayEvents";
        return {
            key: (isMain ? "main" : "sub") + "-heading-" + index,
            id: index.toString(),
            name: heading.name,
            cms: this.cms,
            dict: this.dict,
            eventsCountLength: this.state[eventFunction](heading.id).length,
            marketNames: this.prepareMarketNames(mainHeading, isMain),
            marketTemplates: this.state.getMarketTemplates(mainHeading.sportId),
            cardType: this.state.getSportCardType(mainHeading.sportId),
            renderedHeadings: isMain ? this.renderedMainheadings++ : this.renderedSubheadings++
        };
    };
    EventListPresenter.prototype.getMainHeadingProps = function (mainHeadings, index) {
        var heading = mainHeadings[index];
        return __assign({}, this.getDefaultHeadingProps(index.toString(), heading), {
            subName: heading.subname,
            filterProps: this.getSportFilterProps(),
            shouldCollapse: (mainHeadings.length > 1),
            toggleOddsBtn: this.renderToggleOddsBtn(index)
        });
    };
    EventListPresenter.prototype.getSubHeadingProps = function (mainHeading, subheading) {
        var index = this.state.generateSubheadingId(mainHeading.id, subheading.id);
        return this.getDefaultHeadingProps(index, mainHeading, subheading);
    };
    EventListPresenter.prototype.showPlaceholder = function () {
        return this.state.isMiniEventCard ?
            React.createElement(MiniPlaceholder, { eventsCount: this.cms.EventsCount }) :
            React.createElement(Placeholder, { eventsCount: this.cms.EventsCount });
    };
    EventListPresenter.prototype.showMessage = function () {
        return this.state.isLoading ? this.showPlaceholder() :
            React.createElement(Message, { key: "no-events", text: this.dict.NoEvents, type: MessageStates.info });
    };
    EventListPresenter.prototype.prepareMarketNames = function (mainHeading, isMainHeading) {
        var configuration = this.state.options.dataProvider.cardConfiguration[mainHeading.sportId]
            || this.state.options.dataProvider.cardConfiguration[0];
        var shouldShowNames = this.state.shouldShowNamesInHeading(mainHeading, isMainHeading);
        return shouldShowNames
            ? getHeaderNames(configuration, this.dict, mainHeading.sportId, isMainHeading)
            : [];
    };
    EventListPresenter.prototype.renderViewAllLive = function () {
        return React.createElement(ViewAllBtn, { onClick: this.state.openViewAllLiveLink.bind(this.state), text: this.dict.ViewAllBtn, linkUrl: this.state.getViewAllLiveLink() });
    };
    EventListPresenter.prototype.renderEvents = function (index, events, mainHeading, chunks, subHeading) {
        var id = subHeading ? subHeading.id : mainHeading.id;
        return React.createElement(React.Fragment, null,
            !subHeading && this.state.shouldShowCustomSubheading(mainHeading) && this.renderCustomSubheading(mainHeading),
            React.createElement(RenderEvents, { key: "events-content-" + index, state: this.state, events: events, cms: this.cms, eventChunkHeights: chunks, dict: this.dict }, this.renderViewAllLink(id, mainHeading, subHeading)));
    };
    EventListPresenter.prototype.renderViewAllLink = function (id, mainHeading, subHeading) {
        var linkUrl = subHeading && subHeading.linkUrl ? subHeading.linkUrl : mainHeading.linkUrl || "";
        return React.createElement(React.Fragment, null, React.createElement(ViewAllLink, { key: "view-all-" + id, title: this.dict.ViewAllLink, handler: this.state.openLeagueTranspiler.bind(this.state, mainHeading.sportId, id), href: linkUrl }));
    };
    EventListPresenter.prototype.renderFavoritesSection = function () {
        return React.createElement(RenderFavorites, { name: this.dict.Favorites, cms: this.props.cms, state: this.state, getMarketNames: this.prepareMarketNames.bind(this), getEvents: this.renderEvents.bind(this) });
    };
    EventListPresenter.prototype.renderCustomSubheading = function (mainHeading) {
        var cardType = this.state.getSportCardType(mainHeading.sportId);
        var marketTemplates = [];
        return React.createElement(RenderCustomHeading, { id: mainHeading.id, marketNames: this.prepareMarketNames(mainHeading, false), marketTemplates: marketTemplates, cardType: cardType });
    };
    EventListPresenter.prototype.renderToggleOddsBtn = function (index) {
        return {
            shouldShow: index === 0 && this.state.isMiniEventCard && !this.state.showFavoritesSection,
            toggled: this.state.showOddBtns,
            tooltipMessage: this.state.tooltipMessage,
            onClick: this.state.toggleOddsBtnOnClick
        };
    };
    EventListPresenter.prototype.renderEventsContent = function (mainHeading, mainIndex) {
        var _this = this;
        if (this.state.shouldHideSubheadings) {
            var displayEvents = this.state.displayEvents(mainHeading.id);
            var eventChunkHeights = this.state.getEventsHeight(displayEvents);
            return this.renderEvents(mainIndex, displayEvents, mainHeading, eventChunkHeights);
        }
        else {
            return this.state.displaySubheadings(mainHeading.id).map(function (subheading, subIndex) {
                var eventChunkHeights = _this.state.getEventsHeight(subheading.displayEvents);
                return React.createElement(RenderSubheading, __assign({}, _this.getSubHeadingProps(mainHeading, subheading)), _this.state.showFavoritesSection && subheading.displayEvents.length === 0
                    ? React.createElement(Message, { key: "all-events-in-fav", text: _this.dict.AllEventsInFavorites, type: MessageStates.info })
                    : _this.renderEvents(subIndex, subheading.displayEvents, mainHeading, eventChunkHeights, subheading));
            });
        }
    };
    EventListPresenter.prototype.render = function () {
        var _this = this;
        this.renderedMainheadings = 0;
        this.renderedSubheadings = 0;
        return (React.createElement(React.Fragment, null, !this.state.hasLoadEvents
            ? this.showMessage()
            : React.createElement(React.Fragment, null,
                this.state.showFavoritesSection && this.renderFavoritesSection(),
                this.state.displayMainHeadings.map(function (mainHeading, mainIndex, mainHeadings) {
                    return React.createElement(RenderMainHeading, __assign({}, _this.getMainHeadingProps(mainHeadings, mainIndex), { marketTemplates: _this.state.getMarketTemplates(mainHeading.sportId) }), _this.renderEventsContent(mainHeading, mainIndex));
                }),
                this.cms.ShowViewAllLive && this.renderViewAllLive())));
    };
    EventListPresenter = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], EventListPresenter);
    return EventListPresenter;
}(React.Component));
export { EventListPresenter };
//# sourceMappingURL=EventListPresenter.js.map